import { ActivatedRoute, Router } from '@angular/router';
import { AdmService } from '../../../shared/services/adm.service';
import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { ClasePorEstado, isMobile, isMobileXL, loadData, scrollToInvalidFromControls } from 'src/app/shared/utils/helpers';
import { ComentarioPedidoDialogComponent } from 'src/app/shared/components/comentario-pedido-dialog/comentario-pedido-dialog.component';
import { Compania } from 'src/app/shared/models/compania';
import { ConfigService } from 'src/app/shared/services/config.service';
import { ConfirmacionDialogComponent } from 'src/app/shared/components/confirmacion-dialog/confirmacion-dialog.component';
import { Cuenta } from 'src/app/shared/models/cuenta';
import { CuentaDistribuidor } from 'src/app/shared/models/cuentaDistribuidor';
import { DataClientePedidos } from 'src/app/shared/models/dataClientePedidos';
import { DatePipe, DecimalPipe } from '@angular/common'
import { debounceTime, distinctUntilChanged, filter, finalize, forkJoin, map, startWith, switchMap, tap } from 'rxjs';
import { Direccion } from 'src/app/shared/models/direccion';
import { Division } from 'src/app/shared/models/division';
import { Factura } from 'src/app/shared/models/factura';
import { FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { GrupoCliente } from 'src/app/shared/models/grupoCliente';
import { ItemParametro } from 'src/app/shared/models/itemparametro';
import { ListaPrecioCabecera } from 'src/app/shared/models/listaPrecioCabecera';
import { ListaPrecioItem } from 'src/app/shared/models/listaPrecioItem';
import { LoggedService } from 'src/app/shared/services/logged.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSelect } from '@angular/material/select';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Moneda } from 'src/app/shared/models/moneda';
import { MotivoDevolucionNC } from 'src/app/shared/models/motivoDevolucionNC';
import { NCFacturasDialogComponent } from './nc-facturas-dialog.component';
import { NCItemDialogComponent } from './nc-item-dialog.component';
import { NCLogsDialogComponent } from './nc-logs-dialog.component';
import { NCPedidosRelacionadosDialogComponent } from './nc-pedidos-relacionados-dialog.component';
import { NCRemitosDialogComponent } from './nc-remitos-dialog.component';
import { NCService } from 'src/app/shared/services/nc.service';
import { NotaCreditoCabecera } from 'src/app/shared/models/notaCreditoCabecera';
import { NotaCreditoFactura } from 'src/app/shared/models/notaCreditoFactura';
import { NotaCreditoItem } from 'src/app/shared/models/notaCreditoItem';
import { NotaCreditoRemito } from 'src/app/shared/models/notaCreditoRemito';
import { ParametrosService } from 'src/app/shared/services/parametros.service';
import { PedidoCabecera } from 'src/app/shared/models/pedidoCabecera';
import { PedidoVentaCabecera } from 'src/app/shared/models/pedidoVentaCabecera';
import { PedidoVentaItem } from 'src/app/shared/models/pedidoVentaItem';
import { ProductosService } from 'src/app/shared/services/productos.service';
import { PVService } from 'src/app/shared/services/pv.service';
import { Region } from 'src/app/shared/models/region';
import { SalesOrg } from 'src/app/shared/models/salesOrg';
import { SidenavService } from 'src/app/shared/services/sidenav.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { Stock } from 'src/app/shared/models/stock';
import { TablasService } from 'src/app/shared/services/tablas.service';
import { TerminoPago } from 'src/app/shared/models/terminoPago';
import { TipoNC } from 'src/app/shared/models/tipoNC';
import { UsuariosService } from 'src/app/shared/services/usuarios.service';
import { ZonaVendedor } from 'src/app/shared/models/zonaVendedor';

@Component({
  selector: 'app-nc',
  templateUrl: './nc.component.html'
})
export class NcComponent {

  userName: string = "";

  @ViewChild('nc') nc: ElementRef;
  @ViewChild('top') top: ElementRef;

  displayedColumnsItems = ['acciones', 'nroLinea', 'idProducto', 'producto', 'cantidadVendida', 'cantidadDevolucion', 'precioVenta', 'idMoneda', 'itemFactura', 'idLote', 'importeDevolucionLocal', 'importeDevolucion'];
  dataSourceItems = new MatTableDataSource<NotaCreditoItem>();
  @ViewChild('matSortItems') matSortItems: MatSort;
  @ViewChild('matPaginatorItems') matPaginatorItems: MatPaginator;
  @ViewChild('matPaginatorFacturas') matPaginatorFacturas: MatPaginator;
  @ViewChild('matSortFacturas') matSortFacturas: MatSort;
  @ViewChild('matPaginatorRemitos') matPaginatorRemitos: MatPaginator;
  @ViewChild('matSortRemitos') matSortRemitos: MatSort;
  dataSourceFacturas = new MatTableDataSource<NotaCreditoFactura>();
  dataSourceRemitos = new MatTableDataSource<NotaCreditoRemito>();
  displayedColumnsRemitos = ['acciones', 'nroRemito', 'idProducto', 'idLote', 'cantidad', 'fecha', 'nombrePDF'];
  displayedColumnsFacturas = ['acciones', 'nroLinea', 'nroFactura', 'nroRemito', 'fechaVencimiento', 'idProducto', 'idLote', 'cantidad', 'totalFactura', 'nombrePDF'];

  codigoEdit: number = 0;
  companias: Compania[] = [];
  companiaSeleccionada: Compania;
  ctaDistrubuidorSeleccionada: CuentaDistribuidor;
  cuentasDistribuidores: CuentaDistribuidor[] = []; //Dorados
  direcciones: Direccion[] = [];
  direccionSeleccionada: Direccion;
  divisiones: Division[] = [];
  divisionSeleccionada: Division;
  edicion: boolean;
  gcs: GrupoCliente[] = [];
  gcSeleccionado: GrupoCliente;
  idTipo: number = 0;
  itemFacturaSeleccionado: NotaCreditoItem;
  itemsFactura: NotaCreditoItem[] = [];
  lotes: NotaCreditoItem[] = [];
  loteSeleccionado: NotaCreditoItem = null;
  monedas: Moneda[] = [];
  monedaSeleccionada: Moneda;
  motivoDevolucionSeleccionado: MotivoDevolucionNC = null;
  motivoNCSeleccionado: ItemParametro = null;
  motivosDevolucion: MotivoDevolucionNC[] = []
  motivosNC: ItemParametro[] = [];
  ncCab: NotaCreditoCabecera;
  ncForm: FormGroup;
  ncItemForm: FormGroup;
  regiones: Region[] = [];
  regionSeleccionada: Region;
  rolesConRegion: ItemParametro[] = [];
  salesOrgs: SalesOrg[] = [];
  salesOrgSeleccionada: SalesOrg;
  selectRegiones: boolean = true;
  tipoNCSeleccionado: TipoNC;
  tiposNC: TipoNC[] = [];
  totalImporteDevolucionItems: number = 0;
  alta: boolean = false;
  totalImporteDevolucionLocalItems: number = 0;

  avisoUnidadesPallet: boolean = false;
  mensajeUnidadesPallet: string
  //#region autocomplete Cliente

  clientesEncontrados: any;
  clienteSeleccionado: Cuenta;
  fcAutocompleteCliente = new FormControl('');
  hintC: string = ""
  loadingFcAutocompleteCliente = false;
  minLengthTermCliente = 2;

  //#endregion

  //#region autocomplete ZonaVendedor

  zvsEncontradas: any;
  zvSeleccionada: ZonaVendedor;
  fcAutocompleteZv = new FormControl('');
  hintZV: string = ""
  loadingFcAutocompleteZV = false;
  minLengthTermZV = 2;

  //#endregion

  //#region autocomplete Ítem

  itemsEncontrados: any;
  itemSeleccionado: Factura;
  fcAutocompleteItem = new FormControl('');
  hintItem: string = ""
  loadingFcAutocompleteItem = false;
  minLengthTermItem = 1;

  paramCodigo: string = "";

  //#endregion

  constructor(
    private admService: AdmService,
    private cd: ChangeDetectorRef,
    private configService: ConfigService,
    private ncService: NCService,
    private datePipe: DatePipe,
    private dialog: MatDialog,
    private fb: FormBuilder,
    private loggedService: LoggedService,
    private parametrosService: ParametrosService,
    private productosService: ProductosService,
    private pvService: PVService,
    private router: Router,
    private sidenav: SidenavService,
    private snackBarService: SnackbarService,
    private tablasService: TablasService,
    private activatedRoute: ActivatedRoute,
    private usuarioService: UsuariosService

  ) {



    this.ncForm = this.fb.group({
      idSalesOffice: [''],
      aprobar: [false],
      comentarioLogAutorizacion: [''],
      autor: [''],
      calleNroDireccionEntrega: [''],
      ciudadDireccionEntrega: [''],
      comentarioNC: [''],
      cpDireccionEntrega: [''],
      cuit: [''],
      estado: ['Borrador'],
      devolucionPlanta: [false],
      fechaCreacion: [new Date()],
      fechaFactura: [''],
      fechaPrecio: [new Date()],
      habilitacion: [true],
      idCompania: [''],
      compania: [''],
      idDivision: ['', Validators.required],
      division: [''],
      idEstado: [1],
      idEstadoPendiente: [0],
      idGrupoCliente: ['', Validators.required],
      grupoCliente: [''],
      idMoneda: [''],
      idMotivoDevolucion: ['', Validators.required],
      idMotivoNC: [''],
      idPais: [''],
      idRegion: ['', Validators.required],
      idSalesOrg: [''],
      salesOrg: [''],
      idTipoNC: ['', Validators.required],
      idTipoOrden: ['6'],
      idTipoOrdenOriginal: [''],
      idZonaVendedor: ['', Validators.required],
      items: [[]],
      mensajeIntegracion: [''],
      motivoDevolucion: [''],
      motivoNC: [''],
      nombreCliente: [''],
      nombreClienteDireccionEntrega: ['', Validators.required],
      nombreDistribuidor: [''],
      nroCliente: ['', Validators.required],
      nroClienteDireccionEntrega: ['', Validators.required],
      nroClienteDistribuidor: ['', Validators.required],
      nroFactura: [''],
      nroFacturaSAP: [''],
      nroOrdenSAP: [0],
      nroPedido: [0],
      nroPedidoOriginal: [0],
      nroPedidoRelacionado: [0],
      nroRemito: ['', Validators.required],
      rechazar: [false],
      region: [''],
      rol: [''],
      rolUsuarioSolicitante: [''],
      sFechaCreacion: [this.datePipe.transform(new Date(), 'dd/MM/yyyy')],
      solicitante: [''],
      tipoNC: [''],
      tipoOrden: ['Nota crédito'],
      tipoOrdenOriginal: [''],
      usuarioRedSolicitante: [''],
      usuarioRedZonaVendedor: [''],
      directoCtaDistribuidor: [false],
      enviadoDistribuidor: [false],
      nombreVendedor: [''],
      codigo: [0]
    })

    this.ncItemForm = this.fb.group({

      autor: [''],
      cantidadDevolucion: [1, [Validators.required, Validators.min(0.001)]],
      cantidadVendida: [0],
      comentario: [''],
      cultivo: [''],
      fechaCreacion: [new Date()],
      habilitacion: [true],
      idCompania: [''],
      idDivision: [''],
      idLote: ['', Validators.required],
      idMoneda: [''],
      idPais: [''],
      idPlanta: [''],
      idProducto: ['', Validators.required],
      idSalesOrg: [''],
      idTipoOrden: ['6'],
      importeDevolucion: [0],
      importeDevolucionLocal: [0],
      itemFactura: [0, Validators.required],
      moneda: [''],
      nroFactura: [''],
      nroFacturaSAP: [''],
      nroLinea: [0],
      nroPedido: [0],
      nroRemito: [''],
      precioFinal: [0],
      precioKGL: [0],
      precioVenta: [0],
      producto: ['', Validators.required],
      recargoLocal: [0],
      tipoOrden: ['Nota crédito'],
      total: [0],
      totalDescuento: [0],
      totalLocal: [0],
      totalPrecioKGL: [0],
      codigo: [0]
    })

  }

  public Tooltips: {
    Eliminar: string
    Editar: string
    Ver: string;
  }

  public Validaciones: {
    CantidadDevolucion: string,
    Cliente: string,
    IdDivision: string,
    IdGrupoCliente: string,
    IdLote: string,
    IdRegion: string,
    IdTipoNC: string,
    ItemFactura: string,
    MotivoDevolucion: string,
    NombreClienteDireccionEntrega: string,
    NroClienteDireccionEntrega: string,
    NroClienteDistribuidor: string,
    NroPedidoRelacionado: string,
    PrecioVenta: string,
    ZonaVendedor: string
  }


  public Etiquetas: {
    Fecha: string,
    FechaVencimiento: string,
    TotalFactura: string,
    Acciones: string,
    Buscar: string,
    CalleNroDireccionEntrega: string,
    CantidadDevolucion: string,
    CantidadVendida: string,
    CiudadDireccionEntrega: string,
    Cliente: string,
    Comentario: string,
    Compania: string,
    CPDireccionEntrega: string,
    CuentaDistribuidor: string,
    CuitCliente: string,
    DescripcionItemDescuento: string,
    Descuento: string,
    DescuentoCategoria: string,
    DescuentoDiscrecional: string,
    Direccion: string,
    DireccionEntrega: string,
    Division: string,
    Estado: string,
    FechaCreacion: string
    FechaDesde: string,
    FechaEstado: string,
    FechaHasta: string,
    Glosa: string,
    IdGrupoCliente: string,
    IdLote: string,
    IdMoneda: string,
    IdProducto: string,
    IdTaxClassification: string,
    IdTipoCondicion: string,
    IdTipoListaPrecios: string,
    Importe: string,
    Item: string,
    ItemFactura: string,
    MensajeIntegracion: string,
    MotivoDevolucion: string,
    MotivoNC: string,
    NombreCliente: string,
    NombreClienteDireccionEntrega: string,
    NombreDistribuidor: string,
    NombrePDF: string,
    NroCliente: string
    NroClienteDireccionEntrega: string,
    NroFactura: string,
    NroLinea: string,
    NroOrdenSAP: string
    NroPedido: string;
    NroPedidoRelacionado: string
    NroRemito: string,
    Path: string,
    Porcentaje: string,
    PrecioKGL: string,
    PrecioUnitarioFinal: string,
    PrecioUnitarioLista: string,
    PrecioVenta: string,
    Producto: string,
    Recargo: string,
    Region: string,
    SalesOrg: string,
    SinRegistros: string
    TerminoPago: string,
    Cantidad: string,
    TipoEntrega: string,
    TipoListaPrecios: string,
    TipoNC: string,
    TipoOrden: string,
    Titulo: string,
    Total: string,
    TotalDescuento: string,
    TotalLocal: string,
    TotalPrecioKGL: string,
    ZonaVendedor: string,
    ZonaVendedorSeleccionada: string,
    ImporteDevolucion: string,
    ImporteDevolucionLocal: string,
    SalesOffice: string
  }


  ngAfterViewInit() {

    this.dataSourceFacturas.paginator = this.matPaginatorFacturas;
    this.dataSourceFacturas.sort = this.matSortFacturas;
    this.dataSourceFacturas.sort.disableClear = true;
    this.dataSourceItems.paginator = this.matPaginatorItems;
    this.dataSourceItems.sort = this.matSortItems;
    this.dataSourceItems.sort.disableClear = true;
    this.dataSourceRemitos.paginator = this.matPaginatorRemitos;
    this.dataSourceRemitos.sort = this.matSortRemitos;
    this.dataSourceRemitos.sort.disableClear = true;


  }


  ngOnInit() {
    this.activatedRoute.queryParams.subscribe(params => {
      this.paramCodigo = params.codigo;
      if (typeof this.paramCodigo == 'undefined' || typeof params.idTipo == 'undefined') {
        this.volver();
      }
      if (this.paramCodigo.length) {
        if (!isNaN(+this.paramCodigo)) {
          this.codigoEdit = parseInt(this.paramCodigo);
        }
      }

      if (params.idTipo.length) {
        if (!isNaN(+params.idTipo)) {
          this.idTipo = parseInt(params.idTipo);
        }
      }

    });

    this.Tooltips = {
      Editar: this.configService.tooltips.Editar,
      Eliminar: this.configService.tooltips.Eliminar,
      Ver: this.configService.tooltips.Ver
    }

    this.Validaciones = {
      CantidadDevolucion: this.configService.validaciones.NotasCredito.CantidadDevolucion,
      PrecioVenta: this.configService.validaciones.NotasCredito.PrecioVenta,
      Cliente: this.configService.validaciones.Cliente,
      IdDivision: this.configService.validaciones.IdDivision,
      IdGrupoCliente: this.configService.validaciones.IdGrupoCliente,
      IdLote: this.configService.validaciones.NotasCredito.IdLote,
      IdRegion: this.configService.validaciones.IdRegion,
      IdTipoNC: this.configService.validaciones.NotasCredito.IdTipoNC,
      ItemFactura: this.configService.validaciones.NotasCredito.ItemFactura,
      MotivoDevolucion: this.configService.validaciones.NotasCredito.MotivoDevolucion,
      NombreClienteDireccionEntrega: this.configService.validaciones.NombreClienteDireccionEntrega,
      NroClienteDireccionEntrega: this.configService.validaciones.NroClienteDireccionEntrega,
      NroClienteDistribuidor: this.configService.validaciones.NroClienteDistribuidor,
      NroPedidoRelacionado: this.configService.validaciones.NroPedidoRelacionado,
      ZonaVendedor: this.configService.validaciones.ZonaVendedor

    }

    this.Etiquetas = {
      Fecha: this.configService.etiquetas.Fecha,
      TotalFactura: this.configService.etiquetas.TotalFactura,
      FechaVencimiento: this.configService.etiquetas.FechaVencimiento,
      Acciones: this.configService.etiquetas.Acciones,
      Buscar: this.configService.etiquetas.Buscar,
      CalleNroDireccionEntrega: this.configService.etiquetas.CalleNroDireccionEntrega,
      CantidadDevolucion: this.configService.etiquetas.CantidadDevolucion,
      CantidadVendida: this.configService.etiquetas.CantidadVendida,
      CiudadDireccionEntrega: this.configService.etiquetas.CiudadDireccionEntrega,
      Cliente: this.configService.etiquetas.Cliente,
      Cantidad: this.configService.etiquetas.Cantidad,
      Comentario: this.configService.etiquetas.Comentario,
      Compania: this.configService.etiquetas.Compania,
      CPDireccionEntrega: this.configService.etiquetas.CPDireccionEntrega,
      CuentaDistribuidor: this.configService.etiquetas.CuentaDistribuidor,
      CuitCliente: this.configService.etiquetas.CuitCliente,
      DescripcionItemDescuento: this.configService.etiquetas.DescripcionItemDescuento,
      Descuento: this.configService.etiquetas.Descuento,
      DescuentoCategoria: this.configService.etiquetas.DescuentoCategoria,
      DescuentoDiscrecional: this.configService.etiquetas.DescuentoDiscrecional,
      Direccion: this.configService.etiquetas.PedidosVenta.PV.Direccion,
      DireccionEntrega: this.configService.etiquetas.DireccionEntrega,
      Division: this.configService.etiquetas.FilterDivision,
      Estado: this.configService.etiquetas.Estado,
      FechaCreacion: this.configService.etiquetas.FechaCreacion,
      FechaDesde: this.configService.etiquetas.FechaDesde,
      FechaEstado: this.configService.etiquetas.FechaEstado,
      FechaHasta: this.configService.etiquetas.FechaHasta,
      Glosa: this.configService.etiquetas.Glosa,
      IdGrupoCliente: this.configService.etiquetas.IdGrupoCliente,
      IdLote: this.configService.etiquetas.Inventarios.IdLote,
      IdMoneda: this.configService.etiquetas.IdMoneda,
      IdProducto: this.configService.etiquetas.IdProducto,
      IdTaxClassification: this.configService.etiquetas.IdTaxClassification,
      IdTipoCondicion: this.configService.etiquetas.IdTipoCondicion,
      IdTipoListaPrecios: this.configService.etiquetas.IdTipoListaPrecios,
      Importe: this.configService.etiquetas.Importe,
      ImporteDevolucion: this.configService.etiquetas.ImporteDevolucion,
      ImporteDevolucionLocal: this.configService.etiquetas.ImporteDevolucionLocal,
      Item: this.configService.etiquetas.Item,
      ItemFactura: this.configService.etiquetas.ItemFactura,
      MensajeIntegracion: this.configService.etiquetas.MensajeIntegracion,
      MotivoDevolucion: this.configService.etiquetas.MotivoDevolucion,
      MotivoNC: this.configService.etiquetas.MotivoNC,
      NombreCliente: this.configService.etiquetas.NombreCliente,
      NombrePDF: this.configService.etiquetas.NombrePDF,
      NombreClienteDireccionEntrega: this.configService.etiquetas.NombreClienteDireccionEntrega,
      NombreDistribuidor: this.configService.etiquetas.NombreDistribuidor,
      NroCliente: this.configService.etiquetas.NroCliente,
      NroClienteDireccionEntrega: this.configService.etiquetas.NroClienteDireccionEntrega,
      NroFactura: this.configService.etiquetas.NroFactura,
      NroLinea: this.configService.etiquetas.NroLinea,
      NroOrdenSAP: this.configService.etiquetas.NroOrdenSAP,
      NroPedido: this.configService.etiquetas.NroPedido,
      NroPedidoRelacionado: this.configService.etiquetas.NroPedidoRelacionado,
      NroRemito: this.configService.etiquetas.NroRemito,
      Path: this.configService.etiquetas.PedidosVenta.PV.Path,
      Porcentaje: this.configService.etiquetas.Porcentaje,
      PrecioKGL: this.configService.etiquetas.PrecioKGL,
      PrecioUnitarioFinal: this.configService.etiquetas.PrecioUnitarioFinal,
      PrecioUnitarioLista: this.configService.etiquetas.PrecioUnitarioLista,
      PrecioVenta: this.configService.etiquetas.PrecioVenta,
      Producto: this.configService.etiquetas.Producto,
      Recargo: this.configService.etiquetas.Recargo,
      Region: this.configService.etiquetas.Region,
      SalesOrg: this.configService.etiquetas.SalesOrg,
      SinRegistros: this.configService.etiquetas.SinRegistros,
      TerminoPago: this.configService.etiquetas.TerminoPago,
      TipoEntrega: this.configService.etiquetas.TipoEntrega,
      TipoListaPrecios: this.configService.etiquetas.TipoListaPrecios,
      TipoNC: this.configService.etiquetas.NotasCredito.TipoNC,
      TipoOrden: this.configService.etiquetas.TipoOrden,
      Titulo: this.configService.etiquetas.NotasCredito.NC.Titulo,
      Total: this.configService.etiquetas.Total,
      TotalDescuento: this.configService.etiquetas.TotalDescuento,
      TotalLocal: this.configService.etiquetas.TotalLocal,
      TotalPrecioKGL: this.configService.etiquetas.TotalPrecioKGL,
      ZonaVendedor: this.configService.etiquetas.ZonaVendedor,
      ZonaVendedorSeleccionada: this.configService.etiquetas.ZonaVendedorSeleccionada,
      SalesOffice: this.configService.etiquetas.IdSalesOffice
    }
    this.userName = this.loggedService.logged.userName;
    //#region Inicialización de autocompletables
    this.fcAutocompleteCliente.valueChanges
      .pipe(
        startWith(''),
        filter(res => {
          return typeof res != 'undefined' && res != null && res.length >= this.minLengthTermCliente
        }),
        distinctUntilChanged(),
        debounceTime(1000),
        tap(() => {

          this.clientesEncontrados = [];
          this.loadingFcAutocompleteCliente = true;
        }),
        switchMap(value => this.admService.cClientesPedidoAutocompleteSearch(this.loggedService.logged.idPais, this.ncForm.controls['idCompania'].value, this.ncForm.controls['idSalesOrg'].value, this.loggedService.logged.idDivision, this.loggedService.logged.idZonaVendedor, this.loggedService.logged.idRegion, value)
          .pipe(
            finalize(() => {
              this.loadingFcAutocompleteCliente = false
            }),
          )
        )
      )
      .subscribe((data: Cuenta[]) => {
        this.clientesEncontrados = data;

      });

    this.fcAutocompleteZv.valueChanges
      .pipe(
        startWith(''),
        filter(res => {
          return typeof res != 'undefined' && res != null && res.length >= this.minLengthTermZV
        }),
        distinctUntilChanged(),
        debounceTime(1000),
        tap(() => {

          this.zvsEncontradas = [];
          this.loadingFcAutocompleteZV = true;
        }),
        switchMap(value => this.admService.cZonasVendedoresAutocompleteSearch(this.loggedService.logged.idPais, this.ncForm.controls['idCompania'].value, this.ncForm.controls['idSalesOrg'].value, value)
          .pipe(
            finalize(() => {
              this.loadingFcAutocompleteZV = false
            }),
          )
        )
      )
      .subscribe((data: ZonaVendedor[]) => {
        this.zvsEncontradas = data;


      });

    this.fcAutocompleteItem.valueChanges
      .pipe(
        startWith(''),
        filter(res => {
          return typeof res != 'undefined' && res != null && res.length >= this.minLengthTermItem
        }),
        distinctUntilChanged(),
        debounceTime(1000),
        tap(() => {

          this.itemsEncontrados = [];
          this.loadingFcAutocompleteItem = true;
        }),
        switchMap(value => this.ncService.cPedidoItemsAutocompleteSearch(this.loggedService.logged.idPais, this.ncForm.controls['idCompania'].value,
          this.ncForm.controls['idSalesOrg'].value, this.ncForm.controls['nroFactura'].value, this.ncForm.controls['idTipoOrdenOriginal'].value,
          this.ncForm.controls['nroPedidoOriginal'].value, this.ncForm.controls['idMoneda'].value, value)
          .pipe(
            finalize(() => {
              this.loadingFcAutocompleteItem = false
            }),
          )
        )
      )
      .subscribe((data: Factura[]) => {

        if (data != null && this.ncForm.valid) {
          this.itemsEncontrados = data;

        }
        else {
          this.scrollToInvalidFormControls(this.ncForm);
        }

      });

    //#endregion
    this.ncService
      .cNotaCredito(this.codigoEdit)
      .subscribe((nc: NotaCreditoCabecera) => {

        if (nc != null) {
          forkJoin([
            this.admService.cCompanias(this.loggedService.logged.idPais),
            this.admService.cSalesOrgs(this.loggedService.logged.idPais, this.loggedService.logged.idCompania),
            this.admService.cDivisiones(this.loggedService.logged.idPais, this.loggedService.logged.idCompania, this.loggedService.logged.idSalesOrg, this.loggedService.logged.userName),
            this.ncService.cMotivosDevolucion(this.loggedService.logged.idPais, nc.idCompania, nc.idSalesOrg, nc.idTipoNC, nc.rolUsuarioSolicitante),
            this.parametrosService.cItemParametroXDescripcionItem(25, "NC"), //Cambiar descripcionItem segun tipo de pedido
            this.admService.cTiposNC(this.loggedService.logged.idPais, true), //Tipos NC
            this.parametrosService.cItemsParametros(19), //Motivos NC
            this.parametrosService.cItemsParametros(22) //Roles Alta
          ]).subscribe((data: [Compania[], SalesOrg[], Division[], MotivoDevolucionNC[], ItemParametro, TipoNC[], ItemParametro[], ItemParametro[]]) => {

            if (this.idTipo == 1) {
              if (data[7] != null) {
                if (data[7].length) {
                  if (this.loggedService.validToken()) {
                    data[7].forEach(rol => {
                      if (this.loggedService.logged.rol == rol.idItem && !this.alta) {
                        this.alta = true;
                      }
                    });
                  }
                }
              }
            }
            if (!this.alta && this.idTipo == 1) {
              this.volver();
            }

            if (data[0].length) {

              this.companias = data[0];
              if (this.codigoEdit == 0) {
                this.companiaSeleccionada = data[0][0];
              }

            }

            if (data[1].length) {
              this.salesOrgs = data[1];
              if (this.codigoEdit == 0) {
                this.salesOrgSeleccionada = data[1][0];
              }
            }

            if (data[2].length) {
              this.divisiones = data[2];
            }

            if (data[3].length) {
              this.motivosDevolucion = data[3];
            }

            if (data[5].length) {
              this.tiposNC = data[5];
            }

            if (data[6].length) {
              this.motivosNC = data[6];
            }

            loadData(this.ncForm, nc)

            this.ncForm.controls['idPais'].setValue(this.loggedService.logged.idPais);
            this.seleccionarDivision(this.ncForm.controls['idDivision'].value);
            if (this.codigoEdit == 0) {
              this.ncForm.controls['idTipoNC'].setValue(data[5][0].id);
              this.seleccionarTipoNC(this.ncForm.controls['idTipoNC'].value, null, 0, true);
              this.ncForm.controls['idCompania'].setValue(this.companias[0].id);
              this.ncForm.controls['compania'].setValue(this.companias[0].descripcion);
              this.ncForm.controls['idSalesOrg'].setValue(this.salesOrgs[0].id);
              this.ncForm.controls['salesOrg'].setValue(this.salesOrgs[0].descripcion);
              this.ncForm.controls['idDivision'].setValue(this.divisiones[0].id);
              this.seleccionarDivision(this.ncForm.controls['idDivision'].value)
              this.codigoEdit = nc.codigo;
            }
            else {
              this.ncForm.controls['enviadoDistribuidor'].setValue(nc.enviadoDistribuidor);

              this.ncForm.controls['idDivision'].setValue(nc.idDivision);
              this.ncForm.controls['division'].setValue(nc.division);
              this.companiaSeleccionada = new Compania();
              this.companiaSeleccionada.id = nc.idCompania;
              this.companiaSeleccionada.descripcion = nc.compania;
              this.salesOrgSeleccionada = new SalesOrg();
              this.salesOrgSeleccionada.id = nc.idSalesOrg;
              this.salesOrgSeleccionada.descripcion = nc.salesOrg;
              this.divisionSeleccionada = new Division();
              this.divisionSeleccionada.displayValue = nc.division + ' - ' + nc.idDivision;
              this.motivoDevolucionSeleccionado = new MotivoDevolucionNC();
              this.motivoDevolucionSeleccionado.descripcion = nc.motivoDevolucion;
              this.motivoDevolucionSeleccionado.nroPedidoRelacionado = nc.nroPedidoRelacionado != 0;
              this.tipoNCSeleccionado = new TipoNC();
              this.tipoNCSeleccionado.descripcion = nc.tipoNC

              this.gcSeleccionado = new GrupoCliente();
              this.gcSeleccionado.id = nc.idGrupoCliente;
              this.gcSeleccionado.descripcion = nc.grupoCliente;
              this.gcSeleccionado.displayValue = nc.idGrupoCliente + ' - ' + nc.grupoCliente;

              this.zvSeleccionada = new ZonaVendedor();
              this.zvSeleccionada.displayValue = nc.idZonaVendedor + ' - ' + nc.nombreVendedor;
              this.ctaDistrubuidorSeleccionada = new CuentaDistribuidor();
              this.ctaDistrubuidorSeleccionada.nombre = nc.nombreDistribuidor;

              this.regionSeleccionada = new Region();
              this.regionSeleccionada.displayValue = nc.idRegion + ' - ' + nc.region;

              /*           if (nc.cliente != null) {
                          this.seleccionarCliente(nc.cliente, nc.idGrupoCliente, nc.nroClienteDistribuidor,
                            nc.idRegion, nc.zonaVendedor != null ? nc.zonaVendedor : null, nc.nroPedidoRelacionado)
                        }
           */
              if (nc.idEstado == 1) {
                //se guardo la nc pero no hay items
                this.clienteSeleccionado = new Cuenta();
                this.clienteSeleccionado.idPais = nc.idPais
                this.clienteSeleccionado.idSalesOrg = nc.idSalesOrg
                this.clienteSeleccionado.idCompania = nc.idCompania
                this.clienteSeleccionado.nroCliente = nc.nroCliente

                this.admService
                  .cDataClienteSeleccionado(nc.idPais, nc.idCompania, nc.idSalesOrg, nc.idDivision, nc.nroCliente)
                  .subscribe((datac: DataClientePedidos) => {

                    if (datac != null) {

                      this.regiones = datac.regiones != null ? datac.regiones : [];
                      this.direcciones = datac.direcciones != null ? datac.direcciones : [];
                      this.gcs = datac.gruposCliente != null ? datac.gruposCliente : [];
                      if (this.gcs.length) {
                        if (nc.idGrupoCliente != null) {
                          this.ncForm.controls['idGrupoCliente'].setValue(nc.idGrupoCliente);
                        }
                        else {
                          this.ncForm.controls['idGrupoCliente'].setValue(datac.grupoCliente != null ? datac.grupoCliente.id : '');
                        }
                        this.seleccionarGC(this.ncForm.controls['idGrupoCliente'].value)
                      }
                      this.cuentasDistribuidores = datac.cuentasDistribuidores != null ? datac.cuentasDistribuidores : [];
                      if (this.cuentasDistribuidores.length) {
                        if (nc.nroClienteDistribuidor != null) {
                          this.ncForm.controls['nroClienteDistribuidor'].setValue(nc.nroClienteDistribuidor);
                        }
                        // else {
                        //   if (this.ncForm.controls['idEstado'].value == 1) {
                        //     this.ncForm.controls['nroClienteDistribuidor'].setValue(datac.cuentasDistribuidores[0].nroClienteDistribuidor);
                        //   }
                        // }
                        this.seleccionarCuentaDistribuidor(this.ncForm.controls['nroClienteDistribuidor'].value);

                      }
                      else {
                        this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.ClienteSinDisrtribuidores, 2, 2);
                      }


                      if (nc.idRegion != null) {
                        this.ncForm.controls['idRegion'].setValue(nc.idRegion);
                      }
                      else {
                        if (datac.zonaVendedor?.idRegion?.length) {
                          this.ncForm.controls['idRegion'].setValue(datac.zonaVendedor.idRegion);
                        }
                        else {
                          this.ncForm.controls['idRegion'].setValue(this.regiones != null && this.regiones.length ? this.regiones[0].id : '');
                        }
                      }
                      if (this.ncForm.controls['idRegion'].valid) {
                        this.seleccionarRegion(this.ncForm.controls['idRegion'].value);
                      }

                      this.zvSeleccionada = nc.zonaVendedor != null ? nc.zonaVendedor : (datac.zonaVendedor != null ? datac.zonaVendedor : null);

                      this.ncForm.controls['idZonaVendedor'].setValue(this.zvSeleccionada != null ? this.zvSeleccionada.id : '');
                      this.ncForm.controls['usuarioRedZonaVendedor'].setValue(this.zvSeleccionada != null ? this.zvSeleccionada.usuarioVendedor : '');
                      this.ncForm.controls['nombreVendedor'].setValue(this.zvSeleccionada != null ? this.zvSeleccionada.descripcion : '');

                    }

                  })


              }
              this.dataSourceItems.data = nc.items != null && nc.items.length ? nc.items : [];
              if (this.dataSourceItems.data != null) {
                if (this.dataSourceItems.data.length) {
                  this.totalImporteDevolucionItems = this.dataSourceItems.data.map(a => a.importeDevolucion).reduce(function (a, b) {
                    return a + b;
                  });
                  this.totalImporteDevolucionLocalItems = this.dataSourceItems.data.map(a => a.importeDevolucionLocal).reduce(function (a, b) {
                    return a + b;
                  });


                }
              }
              if (nc.facturas != null) {
                if (nc.facturas.length) {
                  this.dataSourceFacturas.data = nc.facturas;
                }
              }
              if (nc.remitos != null) {
                if (nc.remitos.length) {
                  this.dataSourceRemitos.data = nc.remitos;
                }
              }

            }

            if (nc.idMotivoDevolucion != null) {
              if (nc.idMotivoDevolucion.length) {
                this.motivoDevolucionSeleccionado = this.motivosDevolucion.find(c => c.id == nc.idMotivoDevolucion);
              }
            }
            if (nc.idTipoNC != null) {
              if (nc.idTipoNC.length) {
                this.tipoNCSeleccionado = this.tiposNC.find(c => c.id == nc.idTipoNC);
              }
            }

            let timer = setTimeout(() => {

              this.ncForm.get('idDivision').valueChanges.subscribe(() => { this.limpiarCliente(true); })
              this.ncItemForm.controls['cantidadVendida'].valueChanges.subscribe(() => {
                this.ncItemForm.controls['cantidadDevolucion'].setValidators([Validators.required, Validators.min(0.001), Validators.max(this.ncItemForm.controls['cantidadVendida'].value)]);
                this.ncItemForm.controls['cantidadDevolucion'].updateValueAndValidity();
              })
              //console.log(this.ncForm.value);
              loadData(this.ncItemForm, this.ncForm.value);
              this.ncForm.controls['items'].reset();
              /// this.ncForm.controls['itemsDescuento'].reset();
              this.ncItemForm.controls['codigo'].reset();
              this.ncItemForm.controls['codigo'].setValue(0);

              //console.log(this.ncForm.value);

            }, 2000);

          });
        }

      })
    this.updateCantidadValidator();
    this.updateRemitoValidator();
  
  }
  updateCantidadValidator() {
    this.ncItemForm.get('cantidadDevolucion')?.setValidators([Validators.min(0.001), Validators.max(this.ncItemForm.controls['cantidadVendida'].value)]);
    this.ncItemForm.get('cantidadDevolucion')?.updateValueAndValidity();
  }
  updateRemitoValidator(){
    if (this.ncForm.controls['idTipoNC'].value === '3') { 

      this.ncForm.get('nroRemito')?.setValidators(null);
      this.ncForm.get('nroRemito')?.updateValueAndValidity();
    }

  }
  guardar() {
    if (this.ncForm.valid) {
      let i: NotaCreditoItem[] = []
      i.push(this.ncForm.value);
      this.ncForm.controls['items'].setValue(i);

      this.ncService
        .amNotaCredito(this.ncForm.value)
        .subscribe((data: NotaCreditoCabecera) => {
          if (data != null) {

            this.limpiarItem(true);
            if (this.codigoEdit == 0) {
              this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.AltaExitosa, 1, 2);
            }
            else {
              this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.ModificacionExitosa, 1, 2);
            }
            this.codigoEdit = data.codigo;
            this.ncForm.controls['codigo'].setValue(this.codigoEdit);
            this.ncForm.controls['nroPedido'].setValue(data.nroPedido);
            this.ncItemForm.controls['nroPedido'].setValue(data.nroPedido);
            // this.ncForm.controls['aprobar'].setValue(data.aprobar);
            // this.ncForm.controls['aprobarReservado'].setValue(data.aprobarReservado);
            // this.ncForm.controls['reenviar'].setValue(data.reenviar);
            // this.ncForm.controls['borrador'].setValue(data.borrador);
            // this.ncForm.controls['aprobarParcial'].setValue(data.aprobarParcial);
            // this.ncForm.controls['rechazar'].setValue(data.rechazar);

            this.idTipo == 2
          }

        })
    }
    else {
      this.scrollToInvalidFormControls(this.ncForm);
    }
  }

  limpiarFacturaRemito() {
    this.ncForm.controls['nroPedidoOriginal'].setValue(0);
    this.ncForm.controls['idTipoOrdenOriginal'].reset();
    this.ncForm.controls['tipoOrdenOriginal'].reset();
    this.ncForm.controls['nroRemito'].reset();
    this.ncForm.controls['nroPedidoRelacionado'].setValue(0);
    this.ncForm.controls['nroFactura'].reset();
    this.ncForm.controls['idMotivoNC'].reset();
    this.ncForm.controls['motivoNC'].reset();
    this.ncForm.controls['idMoneda'].reset();
  }


  seleccionarTipoNC(id: any, idMotivoDevolucion: string, nroPedidoRelacionado: number, limpiarFacturaRemito: boolean) {
    this.tipoNCSeleccionado = null;
    this.seleccionarMotivoDevolucion(null, nroPedidoRelacionado);
    this.motivosDevolucion = [];
    this.limpiarItem(true);
    this.updateRemitoValidator();
    if (limpiarFacturaRemito) {
      this.limpiarFacturaRemito();
    }

    if (id != null) {
      this.tipoNCSeleccionado = this.tiposNC.find(c => c.id == this.ncForm.controls['idTipoNC'].value);

      if (this.tipoNCSeleccionado != null) {
        this.ncForm.controls['tipoNC'].setValue(this.tipoNCSeleccionado.descripcion);
        this.ncService.cMotivosDevolucion(this.loggedService.logged.idPais, this.ncForm.controls['idCompania'].value, this.ncForm.controls['idSalesOrg'].value, this.ncForm.controls['idTipoNC'].value, this.ncForm.controls['rolUsuarioSolicitante'].value)
          .subscribe((data: MotivoDevolucionNC[]) => {

            this.motivosDevolucion = [];
            this.ncForm.controls['idMotivoDevolucion'].reset();
            this.ncForm.controls['motivoDevolucion'].reset();
            if (data != null) {
              this.motivosDevolucion = data;
              if (idMotivoDevolucion != null) {
                this.ncForm.controls['idMotivoDevolucion'].setValue(idMotivoDevolucion);
                this.seleccionarMotivoDevolucion(this.ncForm.controls['idMotivoDevolucion'].value, nroPedidoRelacionado);
              }
            }

          })
      }
    }
  }

  seleccionarDivision(d: any) {

    this.divisionSeleccionada = null;
    if (d != null) {
      this.divisionSeleccionada = this.divisiones.find(c => c.id == this.ncForm.controls['idDivision'].value);
      if (this.divisionSeleccionada != null) {
        this.ncForm.controls['division'].setValue(this.divisionSeleccionada.descripcion);
      }
    }
    else {
      this.ncForm.controls['division'].reset();
    }

  }

  seleccionarCliente(c: any, idGrupoCliente: string, nroClienteDistribuidor: string, idRegion: string, zonaVendedor: ZonaVendedor, nroPedidoRelacionado: number) {

    this.seleccionarMotivoDevolucion(null, nroPedidoRelacionado);
    if (idGrupoCliente == null || nroClienteDistribuidor == null || idRegion == null || zonaVendedor == null) {
      this.limpiarFacturaRemito();
    }
    if (c != "-1") {

      this.clienteSeleccionado = c;
      this.ncForm.controls['cuit'].setValue(this.clienteSeleccionado.cuit);
      this.ncForm.controls['nroCliente'].setValue(this.clienteSeleccionado.nroCliente);
      this.ncForm.controls['nombreCliente'].setValue(this.clienteSeleccionado.nombre);
      this.ncForm.controls['idSalesOffice'].setValue(this.clienteSeleccionado.idSalesOffice);

      this.ncForm.controls['calleNroDireccionEntrega'].setValue(this.clienteSeleccionado.calleNro);
      this.ncForm.controls['ciudadDireccionEntrega'].setValue(this.clienteSeleccionado.ciudad);
      this.ncForm.controls['cpDireccionEntrega'].setValue(this.clienteSeleccionado.codigoPostal);
      this.ncForm.controls['nombreClienteDireccionEntrega'].setValue(this.clienteSeleccionado.nombre);
      this.ncForm.controls['nroClienteDireccionEntrega'].setValue(this.clienteSeleccionado.nroCliente);
      this.fcAutocompleteZv.reset();

      this.admService
        .cDataClienteSeleccionado(this.clienteSeleccionado.idPais, this.clienteSeleccionado.idCompania, this.clienteSeleccionado.idSalesOrg, this.ncForm.controls['idDivision'].value, this.clienteSeleccionado.nroCliente)
        .subscribe((data: DataClientePedidos) => {

          if (data != null) {

            this.regiones = data.regiones != null ? data.regiones : [];
            this.direcciones = data.direcciones != null ? data.direcciones : [];
            this.gcs = data.gruposCliente != null ? data.gruposCliente : [];
            if (this.gcs.length) {
              if (this.clienteSeleccionado.idTipoCliente != null) {
                this.ncForm.controls['idGrupoCliente'].setValue(this.clienteSeleccionado.idTipoCliente);
              }
              else {
                this.ncForm.controls['idGrupoCliente'].setValue(data.grupoCliente != null ? data.grupoCliente.id : '');
              }
              this.seleccionarGC(this.ncForm.controls['idGrupoCliente'].value)
            }
            this.cuentasDistribuidores = data.cuentasDistribuidores != null ? data.cuentasDistribuidores : [];
            if (this.cuentasDistribuidores.length) {
              if (nroClienteDistribuidor != null) {
                this.ncForm.controls['nroClienteDistribuidor'].setValue(nroClienteDistribuidor);
              }
              else {
                if (this.ncForm.controls['idEstado'].value == 1) {
                  this.ncForm.controls['nroClienteDistribuidor'].setValue(data.cuentasDistribuidores[0].nroClienteDistribuidor);
                }
              }
              this.seleccionarCuentaDistribuidor(this.ncForm.controls['nroClienteDistribuidor'].value);

            }
            else {
              this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.ClienteSinDisrtribuidores, 2, 2);
            }

            if (idRegion != null) {
              this.ncForm.controls['idRegion'].setValue(idRegion);
            }
            else {
              if (data.zonaVendedor?.idRegion?.length) {
                this.ncForm.controls['idRegion'].setValue(data.zonaVendedor.idRegion);
              }
              else {
                this.ncForm.controls['idRegion'].setValue(this.regiones != null && this.regiones.length ? this.regiones[0].id : '');
              }
            }
            if (this.ncForm.controls['idRegion'].valid) {
              this.seleccionarRegion(this.ncForm.controls['idRegion'].value);
            }

            this.zvSeleccionada = zonaVendedor != null ? zonaVendedor : (data.zonaVendedor != null ? data.zonaVendedor : null);
            //this.ncForm.controls['idRegion'].setValue(data.zonaVendedor?.idRegion?.length ? data.zonaVendedor.idRegion : this.regiones[0].id);
            this.ncForm.controls['idZonaVendedor'].setValue(this.zvSeleccionada != null ? this.zvSeleccionada.id : '');
            this.ncForm.controls['usuarioRedZonaVendedor'].setValue(this.zvSeleccionada != null ? this.zvSeleccionada.usuarioVendedor : '');
            this.ncForm.controls['nombreVendedor'].setValue(this.zvSeleccionada != null ? this.zvSeleccionada.descripcion : '');

          }

        })

    }
    else {
      this.ncForm.controls['idRegion'].reset();
      this.ncForm.controls['idGrupoCliente'].reset();
      this.ncForm.controls['cuit'].reset();
      this.ncForm.controls['nroCliente'].reset();
      this.ncForm.controls['nombreCliente'].reset();
      this.ncForm.controls['idSalesOffice'].reset();
      this.ncForm.controls['calleNroDireccionEntrega'].reset();
      this.ncForm.controls['ciudadDireccionEntrega'].reset();
      this.ncForm.controls['cpDireccionEntrega'].reset();
      this.ncForm.controls['nombreClienteDireccionEntrega'].reset();
      this.ncForm.controls['nroClienteDireccionEntrega'].reset();
      this.clienteSeleccionado = null;
    }

  }

  limpiarCliente(resetFormControl: boolean) {
    this.clientesEncontrados = [];

    this.limpiarVendedor(true);
    this.seleccionarCliente("-1", null, null, null, null, 0);
    this.seleccionarCuentaDistribuidor(null);
    this.seleccionarRegion(null);
    this.ncForm.controls['idMotivoDevolucion'].reset();
    this.ncForm.controls['nroClienteDistribuidor'].reset();
    this.cuentasDistribuidores = [];
    this.gcs = [];
    this.regiones = [];
    if (resetFormControl) {
      this.fcAutocompleteCliente.setValue('');

    }
    this.ncForm.markAsUntouched();
    this.ncForm.markAsPristine();


  }


  getOptionTextCliente(option) {
    if (option != null) {
      return option.displayValue;
    }
  }

  handleEmptyInputCliente(event: any) {
    if (event.target.value === '' || event.target.value.length < this.minLengthTermCliente) {
      this.clientesEncontrados = [];
      this.clienteSeleccionado = null;

    }
  }

  seleccionarCuentaDistribuidor(d: any) {
    this.ctaDistrubuidorSeleccionada = null;
    if (d != null) {
      this.ctaDistrubuidorSeleccionada = this.cuentasDistribuidores.length == 1 ? this.cuentasDistribuidores[0] : this.cuentasDistribuidores.find(c => c.nroClienteDistribuidor == d)
      if (this.ctaDistrubuidorSeleccionada != null) {
        this.ncForm.controls['nombreDistribuidor'].setValue(this.ctaDistrubuidorSeleccionada.nombre);
        this.ncForm.controls['directoCtaDistribuidor'].setValue(this.ctaDistrubuidorSeleccionada.directo);
        this.ncForm.controls['devolucionPlanta'].setValue(this.ctaDistrubuidorSeleccionada.directo);
      }
    }
    else {
      this.ncForm.controls['nombreDistribuidor'].reset();
      this.ncForm.controls['directoCtaDistribuidor'].reset();
    }
  }

  seleccionarGC(g: any) {

    this.gcSeleccionado = null;
    if (g != null) {
      this.gcSeleccionado = this.gcs.find(c => c.id == this.ncForm.controls['idGrupoCliente'].value);
      if (this.gcSeleccionado != null) {
        this.ncForm.controls['grupoCliente'].setValue(this.gcSeleccionado.descripcion);
      }
    }
    else {
      this.ncForm.controls['grupoCliente'].reset();
    }
  }

  seleccionarZonaVendedor(zv: any) {
    this.zvSeleccionada = zv;
    this.ncForm.controls['idZonaVendedor'].setValue(this.zvSeleccionada.id);
    this.ncForm.controls['usuarioRedZonaVendedor'].setValue(this.zvSeleccionada != null ? this.zvSeleccionada.usuarioVendedor : '');
    this.ncForm.controls['nombreVendedor'].setValue(this.zvSeleccionada != null ? this.zvSeleccionada.descripcion : '');

    if (this.regiones.length) {

      this.ncForm.controls['idRegion'].setValue(this.zvSeleccionada.idRegion);
    }
  }

  getOptionTextZV(option) {
    if (option != null) {
      return option.displayValue;
    }
  }

  handleEmptyInputVendedor(event: any) {
    if (event.target.value === '' || event.target.value.length < this.minLengthTermZV) {
      this.limpiarVendedor(false);
    }
  }
  limpiarVendedor(resetFormControl: boolean) {
    this.zvsEncontradas = [];
    this.zvSeleccionada = null;
    this.ncForm.controls['idZonaVendedor'].reset();
    this.ncForm.controls['idRegion'].reset();
    this.ncForm.controls['usuarioRedZonaVendedor'].reset();
    this.ncForm.controls['nombreVendedor'].reset();
    if (resetFormControl) {
      this.fcAutocompleteZv.setValue('');
    }

  }

  seleccionarRegion(r: any) {

    this.regionSeleccionada = null;
    if (r != null) {
      this.regionSeleccionada = this.regiones.find(c => c.id == this.ncForm.controls['idRegion'].value);
      if (this.regionSeleccionada != null) {
        this.ncForm.controls['region'].setValue(this.regionSeleccionada.descripcion);
      }
    }
    else {
      this.ncForm.controls['region'].reset();
    }

  }

  dialogFacturas() {
    let config: MatDialogConfig = new MatDialogConfig();
    config.width = '100%';
    config.height = 'auto';
    config.data = { cab: this.ncForm.value }
    let dialogRef = this.dialog.open(NCFacturasDialogComponent, config);
    dialogRef.afterClosed().subscribe((data: Factura) => {
      if (data != null) {
        if (typeof data != 'string') {
          this.ncForm.controls['fechaFactura'].setValue(data.fechaVencimiento);
          this.ncForm.controls['idMoneda'].setValue(data.idMoneda);
          this.ncForm.controls['idTipoOrdenOriginal'].setValue(data.idTipoOrden);
          this.ncForm.controls['nroFactura'].setValue(data.nroFactura);
          this.ncForm.controls['nroFacturaSAP'].setValue(data.nroFacturaSAP);
          this.ncForm.controls['nroPedidoOriginal'].setValue(data.nroPedido);
          //this.ncForm.controls['nroRemito'].setValue(data.nroRemito != null ? data.nroRemito : "");
          this.ncForm.controls['tipoOrdenOriginal'].setValue(data.tipoOrden);

        }
      }
    })
  }

  dialogRemitos() {
    let config: MatDialogConfig = new MatDialogConfig();
    config.width = '100%';
    config.height = 'auto';
    config.data = { cab: this.ncForm.value }
    let dialogRef = this.dialog.open(NCRemitosDialogComponent, config);
    dialogRef.afterClosed().subscribe((data: Factura) => {
      if (data != null) {
        if (typeof data != 'string') {
          this.ncForm.controls['nroRemito'].setValue(data.nroRemito != null ? data.nroRemito : "");
        }
      }
    })
  }

  seleccionarMotivoDevolucion(md: any, nroPedidoRelacionado: number) {

    this.motivoDevolucionSeleccionado = null;
    this.ncForm.controls['nroPedidoRelacionado'].clearValidators();
    this.ncForm.controls['nroPedidoRelacionado'].setValue(nroPedidoRelacionado);
    if (md != null) {
      this.motivoDevolucionSeleccionado = this.motivosDevolucion.find(c => c.id == this.ncForm.controls['idMotivoDevolucion'].value);
      if (this.motivoDevolucionSeleccionado != null) {
        this.ncForm.controls['motivoDevolucion'].setValue(this.motivoDevolucionSeleccionado.descripcion);
        if (this.motivoDevolucionSeleccionado.nroPedidoRelacionado) {
          this.ncForm.controls['nroPedidoRelacionado'].setValidators([Validators.required, Validators.min(1)]);
        }

      }
    }
    else {
      this.ncForm.controls['motivoDevolucion'].reset();
      this.ncForm.controls['idMotivoDevolucion'].reset();
    }
    this.ncForm.controls['nroPedidoRelacionado'].updateValueAndValidity();
  }

  dialogPedidosRelacionados() {
    let config: MatDialogConfig = new MatDialogConfig();
    config.width = '100%';
    config.height = 'auto';
    config.data = { cab: this.ncForm.value }
    let dialogRef = this.dialog.open(NCPedidosRelacionadosDialogComponent, config);
    dialogRef.afterClosed().subscribe((data: PedidoCabecera) => {
      if (data != null) {
        if (typeof data != 'string') {
          this.ncForm.controls['nroPedidoRelacionado'].setValue(data.nroPedido != null ? data.nroPedido : 0);

        }
      }
    })
  }

  seleccionarMotivoNC(m: any) {

    this.motivoNCSeleccionado = null;
    if (m != null) {
      this.motivoNCSeleccionado = this.motivosNC.find(c => c.idItem == this.ncForm.controls['idMotivoNC'].value);
      if (this.motivoNCSeleccionado != null) {
        this.ncForm.controls['motivoNC'].setValue(this.motivoNCSeleccionado.descripcion);
      }
    }
    else {
      this.ncForm.controls['motivoNC'].reset();
    }

  }


  getOptionTextItem(option) {
    if (option != null) {
      return option.displayValue;
    }
  }

  handleEmptyInputItem(event: any) {
    if (event.target.value === '' || event.target.value.length < this.minLengthTermItem) {
      this.itemsEncontrados = [];
      this.itemSeleccionado = null;
    }
  }

  limpiarItem(resetFormControl: boolean) {
    this.itemsEncontrados = [];
    this.ncItemForm.controls['cantidadDevolucion'].setValue(1);
    this.ncItemForm.controls['cantidadVendida'].setValue(null);
    this.avisoUnidadesPallet = false
    this.lotes = [];
    this.loteSeleccionado = null;
    this.itemsFactura = [];
    this.ncItemForm.controls['idLote'].setValue(-1);
    this.seleccionarItem("-1");
    if (resetFormControl) {
      this.fcAutocompleteItem.setValue('');
    }
    this.updateCantidadValidator();

  }

  seleccionarItem(i: any) {

    if (i != "-1") {
      this.itemSeleccionado = i;
      this.ncItemForm.controls['idPlanta'].setValue(this.itemSeleccionado.idPlanta);
      this.ncItemForm.controls['idProducto'].setValue(this.itemSeleccionado.idProducto);
      this.ncItemForm.controls['producto'].setValue(this.itemSeleccionado.producto);
      this.ncItemForm.controls['idLote'].reset();
      this.ncItemForm.controls['itemFactura'].reset();

      forkJoin([

        this.ncService.cLotesItem(this.loggedService.logged.idPais, this.ncForm.controls['idCompania'].value, this.ncForm.controls['idSalesOrg'].value, this.ncForm.controls['nroFactura'].value,
          this.ncForm.controls['idTipoOrdenOriginal'].value, this.ncForm.controls['nroPedidoOriginal'].value, this.ncItemForm.controls['idProducto'].value, this.ncForm.controls['nroRemito'].value),
        this.ncService.cItemsFactura(this.loggedService.logged.idPais, this.ncForm.controls['idCompania'].value, this.ncForm.controls['idSalesOrg'].value, this.ncForm.controls['nroFactura'].value,
          this.ncForm.controls['idTipoOrdenOriginal'].value, this.ncForm.controls['nroPedidoOriginal'].value, this.ncItemForm.controls['idProducto'].value)

      ]).subscribe((data: [NotaCreditoItem[], NotaCreditoItem[]]) => {
        this.lotes = [];
        this.itemsFactura = [];
        if (this.ncForm.controls['idTipoNC'].value == "1") {  //Con movimiento de stock
          this.ncItemForm.controls['itemFactura'].clearValidators();
          this.ncItemForm.controls['idLote'].setValidators([Validators.required]);
          this.seleccionarItemFactura(null);
          this.ncItemForm.controls['precioVenta'].clearValidators();

          if (data[0] != null) {
            if (data[0].length) {
              this.lotes = data[0];
              if (this.lotes.length == 1) {
                this.loteSeleccionado = this.lotes[0];
                this.ncItemForm.controls['idLote'].setValue(this.loteSeleccionado.idLote);
                this.seleccionarLote(this.ncItemForm.controls['idLote'].value);
              }
            }
          }

        }
        else { //Sin movimiento de stock o Venta anticipada
          this.ncItemForm.controls['idLote'].clearValidators();
          this.ncItemForm.controls['itemFactura'].setValidators([Validators.required]);
          this.ncItemForm.controls['precioVenta'].setValidators([Validators.required, Validators.min(1)]);
          this.seleccionarLote(null);
          if (data[1] != null) {
            if (data[1].length) {
              this.itemsFactura = data[1];
              if (this.itemsFactura.length == 1) {
                this.itemFacturaSeleccionado = this.itemsFactura[0];
                this.ncItemForm.controls['itemFactura'].setValue(this.itemFacturaSeleccionado.nroLinea); //itemFactura = Nro de linea del item en la factura
                this.seleccionarItemFactura(this.ncItemForm.controls['itemFactura'].value);
              }
            }
          }

        }
        this.ncItemForm.controls['idLote'].updateValueAndValidity();
        this.ncItemForm.controls['itemFactura'].updateValueAndValidity();
        this.ncItemForm.controls['precioVenta'].updateValueAndValidity();

      });

    }
    else {
      this.ncItemForm.controls['idProducto'].reset();
      this.ncItemForm.controls['producto'].reset();
      this.ncItemForm.controls['idPlanta'].reset();
      this.ncItemForm.controls['precioVenta'].setValue(0);
      this.ncItemForm.controls['precioVenta'].clearValidators();
this.ncItemForm.controls['precioVenta'].updateValueAndValidity();
      this.ncItemForm.markAsUntouched();
      this.ncItemForm.markAsPristine();
      this.itemSeleccionado = null;
    }
  }

  seleccionarLote(l: any) {
    this.loteSeleccionado = null;
    if (l != null) {
      this.loteSeleccionado = this.lotes.find(c => c.idLote == this.ncItemForm.controls['idLote'].value);
      if (this.itemSeleccionado != null && this.loteSeleccionado != null) {
        this.ncService
          .cDataItemLote(this.clienteSeleccionado.idPais, this.ncForm.controls['idCompania'].value, this.ncForm.controls['idSalesOrg'].value,
            this.ncForm.controls['nroFactura'].value, this.ncForm.controls['idTipoOrdenOriginal'].value,
            this.ncForm.controls['nroPedidoOriginal'].value, this.ncItemForm.controls['idProducto'].value,
            this.ncForm.controls['nroRemito'].value, this.loteSeleccionado.nroLinea, this.loteSeleccionado.idLote, this.loteSeleccionado.cantidadVendida)
          .subscribe((data: Factura) => {
            if (data != null) {
              //console.log(data);
              this.ncItemForm.controls['precioVenta'].setValue(data.precioUnitarioLista);
              this.ncItemForm.controls['cantidadVendida'].setValue(data.cantidad);
            }

          })
      }
    }
    else {
      this.ncItemForm.controls['precioVenta'].reset();
      this.ncItemForm.controls['cantidadVendida'].reset();
    }
  }

  seleccionarItemFactura(i: any) {
    this.itemFacturaSeleccionado = null;
    if (i != null) {
      this.itemFacturaSeleccionado = this.itemsFactura.find(c => c.nroLinea == this.ncItemForm.controls['itemFactura'].value);
      if (this.itemSeleccionado != null && this.itemFacturaSeleccionado != null) {
        this.ncService
          .cDataItemFactura(this.clienteSeleccionado.idPais, this.ncForm.controls['idCompania'].value, this.ncForm.controls['idSalesOrg'].value, this.ncForm.controls['nroFactura'].value, this.ncForm.controls['idTipoOrdenOriginal'].value,
            this.ncForm.controls['nroPedidoOriginal'].value, this.ncItemForm.controls['idProducto'].value, this.ncItemForm.controls['itemFactura'].value)
          .subscribe((data: Factura) => {

            if (data != null) {

              this.ncItemForm.controls['precioVenta'].setValue(data.precioUnitarioLista);
              this.ncItemForm.controls['cantidadVendida'].setValue(data.cantidad);
            }

          })
      }
    }
    else {
      this.ncItemForm.controls['precioVenta'].reset();
      this.ncItemForm.controls['cantidadVendida'].reset();
    }
  }


  nuevoItem() {
    if (this.itemSeleccionado.unidadesPallet == 0) {
      this.avisoUnidadesPallet = true
      this.mensajeUnidadesPallet = "No existen Kg/Litros para el producto"
    }
    else {

      const cantidadNum: number = this.ncItemForm.controls['cantidadDevolucion'].value;
      const unidadesPallet = this.itemSeleccionado.unidadesPallet
      var esMultiplo =  Math.abs(cantidadNum / unidadesPallet - Math.round(cantidadNum / unidadesPallet)) < 1e-10;
      let valornum = cantidadNum / unidadesPallet

      if (!esMultiplo) {
        this.avisoUnidadesPallet = true;
        valornum = Math.floor(valornum) + 1
this.mensajeUnidadesPallet = "La cantidad no corresponde a los Kg/Litros (" + unidadesPallet.toString() + "), cantidad sugerida: "
          + parseFloat((unidadesPallet * (valornum - 1)).toFixed(3)).toString() + " ó " 
          + parseFloat((unidadesPallet * valornum).toFixed(3)).toString();
      } else {
        this.avisoUnidadesPallet = false;
      }
    }

    if (this.itemSeleccionado == null && this.ncForm.valid) {
      this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, "Seleccioná un ítem.", 2, 2);
    }

    if (this.ncForm.valid && this.ncItemForm.valid && !this.avisoUnidadesPallet) {

      let i: NotaCreditoItem[] = []
      i.push(this.ncItemForm.value);
      this.ncForm.controls['items'].setValue(i);
      this.ncItemForm.controls['autor'].setValue(this.loggedService.logged.userName);

      this.ncService
        .aNotaCreditoItem(this.ncForm.value)
        .subscribe((data: NotaCreditoCabecera) => {
          if (data != null) {
            this.ncForm.controls['aprobar'].setValue(data.aprobar);
            this.ncForm.controls['rechazar'].setValue(data.rechazar);
            // this.ncForm.controls['aprobarReservado'].setValue(data.aprobarReservado);
            // this.ncForm.controls['reenviar'].setValue(data.reenviar);
            // this.ncForm.controls['borrador'].setValue(data.borrador);
            // this.ncForm.controls['aprobarParcial'].setValue(data.aprobarParcial);

            this.limpiarItem(true);
            if (this.codigoEdit == 0) {
              this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.AltaExitosa, 1, 2);
            }
            else {
              this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.ModificacionExitosa, 1, 2);
            }
            if (data.items != null) {
              if (data.items.length) {
                this.dataSourceItems.data = data.items;
                this.totalImporteDevolucionItems = this.dataSourceItems.data.map(a => a.importeDevolucion).reduce(function (a, b) {
                  return a + b;
                });
                this.totalImporteDevolucionLocalItems = this.dataSourceItems.data.map(a => a.importeDevolucionLocal).reduce(function (a, b) {
                  return a + b;
                });


              }
            }

            this.codigoEdit = data.codigo;
            this.ncForm.controls['codigo'].setValue(this.codigoEdit);
            this.ncForm.controls['items'].reset();
            this.idTipo == 2
            //console.log(data);
          }

        })
    }
    else {
      if ((!this.ncForm.valid && this.ncItemForm.valid) || (!this.ncForm.valid && !this.ncItemForm.valid)) {
        this.scrollToInvalidFormControls(this.ncForm);
      }
      else {
        this.scrollToInvalidFormControls(this.ncItemForm);
      }
    }


  }

  eliminarItem(item: NotaCreditoItem) {
    this.dialog
      .open(ConfirmacionDialogComponent, { panelClass: 'app-dialog', data: "¿Confirmas la eliminación del producto " + item.idProducto + " - " + item.producto + "?", width: 'auto', height: 'auto' })
      .afterClosed()
      .subscribe((Si: boolean) => {
        if (Si) {
          this.ncService.bNotaCreditoItem(this.codigoEdit, item.codigo).subscribe((data: NotaCreditoCabecera) => {

            if (data != null) {

              this.limpiarItem(true);
              this.ncForm.controls['aprobar'].setValue(data.aprobar);
              this.ncForm.controls['rechazar'].setValue(data.rechazar);
              this.dataSourceItems.data = [];
              this.totalImporteDevolucionItems = 0;
              this.totalImporteDevolucionLocalItems = 0;
              if (data.items != null) {
                if (data.items.length) {
                  this.dataSourceItems.data = data.items;
                  this.totalImporteDevolucionItems = this.dataSourceItems.data.map(a => a.importeDevolucion).reduce(function (a, b) {
                    return a + b;
                  });
                  this.totalImporteDevolucionLocalItems = this.dataSourceItems.data.map(a => a.importeDevolucionLocal).reduce(function (a, b) {
                    return a + b;
                  });


                }
              }

              // this.ncForm.controls['aplicaDescDisc'].setValue(data.aplicaDescDisc);
              // this.ncForm.controls['aplicaDtoDiscrecionalxLP'].setValue(data.aplicaDtoDiscrecionalxLP);
              // this.ncForm.controls['aplicaPrecioFijoxLP'].setValue(data.aplicaPrecioFijoxLP);
              // this.ncForm.controls['aprobar'].setValue(data.aprobar);
              // this.ncForm.controls['aprobarParcial'].setValue(data.aprobarParcial);
              // this.ncForm.controls['aprobarReservado'].setValue(data.aprobarReservado);
              // this.ncForm.controls['borrador'].setValue(data.borrador);
              // this.ncForm.controls['descuentoCategoria'].setValue(data.descuentoCategoria);
              // this.ncForm.controls['descuentoDiscrecional'].setValue(data.descuentoDiscrecional);
              // this.ncForm.controls['preciosFijos'].setValue(data.preciosFijos);
              // this.ncForm.controls['recargo'].setValue(data.recargo);
              // this.ncForm.controls['recargoLocal'].setValue(data.recargoLocal);
              // this.ncForm.controls['rechazar'].setValue(data.rechazar);
              // this.ncForm.controls['reenviar'].setValue(data.reenviar);
              this.ncForm.controls['items'].reset();
              this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.EliminacionExitosa, 1, 2);
            }
          })
        }
      })
  }

  dialogLogAutorizaciones() {
    let config: MatDialogConfig = new MatDialogConfig();
    config.width = '100%';
    config.height = 'auto';
    config.data = { cab: this.ncForm.value }
    let dialogRef = this.dialog.open(NCLogsDialogComponent, config);
    dialogRef.afterClosed().subscribe((data: string) => {

    })
  }

  dialogItem(item: NotaCreditoItem) {

    let config: MatDialogConfig = new MatDialogConfig();
    config.width = '100%';
    config.height = 'auto';
    let cab: NotaCreditoCabecera = this.ncForm.value;
    let nci: NotaCreditoItem = structuredClone(item);
    cab.items = [];
    cab.items.push(nci);
    config.data = { cab: cab }
    let dialogRef = this.dialog.open(NCItemDialogComponent, config);

    dialogRef.afterClosed().subscribe((data: number) => {
      if (data != 0) {
        this.ncService.cNotaCredito(this.codigoEdit).subscribe((data: NotaCreditoCabecera) => {
          if (data != null) {
            this.ncForm.controls['aprobar'].setValue(data.aprobar);
            this.ncForm.controls['rechazar'].setValue(data.rechazar);
            this.limpiarItem(true);
            this.dataSourceItems.data = [];
            this.totalImporteDevolucionItems = 0;
            this.totalImporteDevolucionLocalItems = 0;
            this.dataSourceItems.data = data.items != null && data.items.length ? data.items : [];
            if (this.dataSourceItems.data != null) {
              if (this.dataSourceItems.data.length) {

                this.totalImporteDevolucionItems = this.dataSourceItems.data.map(a => a.importeDevolucion).reduce(function (a, b) {
                  return a + b;
                });
                this.totalImporteDevolucionLocalItems = this.dataSourceItems.data.map(a => a.importeDevolucionLocal).reduce(function (a, b) {
                  return a + b;
                });


              }
            }
            this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.ModificacionExitosa, 1, 2);
          }

        })
      }
    })

  }

  dialogComentario(idTipo: number, required: boolean) {
    let config: MatDialogConfig = new MatDialogConfig();
    config.width = '100%';
    config.height = 'auto';
    config.data = { required: required }
    let dialogRef = this.dialog.open(ComentarioPedidoDialogComponent, config);
    dialogRef.afterClosed().subscribe((data: string) => {
      if (data != null && typeof data != 'undefined') {
        this.ncForm.controls['comentarioLogAutorizacion'].setValue(data);
        //console.log(this.ncForm.controls['comentarioLogAutorizacion'].value);

        switch (idTipo) {
          case 1: //Aprobar

            this.ncService.aprobarNotaCredito(this.ncForm.value).subscribe((data: NotaCreditoCabecera) => {
              if (data != null) {
                this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.AprobacionPedidoExitosa, 1, 2);
                this.regresarALaRutaAnterior();
              }

            })

            break;
          case 2: //Rechazar

            this.ncService.rechazarNotaCredito(this.ncForm.value).subscribe((data: NotaCreditoCabecera) => {
              if (data != null) {
                this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, this.configService.mensajes.RechazoPedidoExitoso, 1, 2);

                this.regresarALaRutaAnterior();
              }

            })


        }


      }
    })
  }


  compareItemsFactura(itemLista: any, itemNC: any): boolean {
    return itemLista == itemNC;
  }

  compareLotes(loteLista: any, loteNC: any): boolean {
    return loteLista == loteNC;
  }

  compareTipoNC(tipoLista: any, tipoNC: any): boolean {
    return tipoLista == tipoNC;
  }

  compareMotivosDevolucion(dLista: any, dNC: any): boolean {
    return dNC == dLista;
  }

  compareMotivosNC(mNCLista: any, mNC: any): boolean {
    return mNCLista == mNC;
  }

  compareSalesOrgs(salesOrgLista: any, salesOrgNC: any): boolean {
    return salesOrgLista == salesOrgNC;
  }
  compareDivisiones(dLista: any, dNC: any): boolean {
    return dLista == dNC;
  }

  compareGC(gcLista: any, gcNC: any): boolean {
    return gcLista == gcNC;
  }

  compareRegiones(rLista: any, rNC: any): boolean {
    return rLista == rNC;
  }

  compareDirecciones(dLista: any, dNC: any): boolean {
    return dLista == dNC;
  }
  compareCuentasDistribuidores(dLista: any, dNC: any): boolean {
    return dLista == dNC;
  }

  clasePorEstado(id: string) {
    let clase = ClasePorEstado("1", id);
    return clase;
  }

  scrollToInvalidFormControls(fg: FormGroup) {
    scrollToInvalidFromControls(this.nc, fg);
  }

  volver() {
    this.router.navigateByUrl(this.configService.etiquetas.NotasCredito.Buscador.Path);
  }
  regresarALaRutaAnterior() {
    if (this.router.lastSuccessfulNavigation.extras.replaceUrl == undefined || this.router.lastSuccessfulNavigation.extras.replaceUrl) {
      var state = this.router.lastSuccessfulNavigation.extras.state;
      if (state) {
        this.router.navigateByUrl(state.rutaAnterior || '/');
      }
      else {
        this.volver();
      }
    }
    else {
      this.volver();
    }
  }

  isLogged() {
    return this.loggedService.logged != null;
  }

  isNewUser() {
    if (this.loggedService.logged != null) {
      return this.loggedService.logged.newUser;
    }
    else {
      return false
    }
  }

  isMobileXL() {
    return isMobileXL();
  }

  isMobile() {
    return isMobile();
  }
  isInRole(rol: string): boolean {
    return this.loggedService.isInRole(rol);
  }

  download(nombrepdf: string) {
    this.admService.downloadPdf(nombrepdf).subscribe(blob => {
      const url = window.URL.createObjectURL(blob);
      const anchor = document.createElement('a');
      anchor.href = url;
      anchor.download = nombrepdf;
      anchor.click();
      window.URL.revokeObjectURL(url);
    }, error => {
      console.error('Error downloading file:', error);
    });
  }

  envioMailDistribuidor() {
    this.admService.enviarMailaDistribuidor(this.ncForm.value.nroPedido, this.ncForm.value.idTipoOrden, this.ncForm.value.nroClienteDistribuidor).subscribe(response => {
      console.log('Respuesta del servidor:', response);
      this.snackBarService.openSnackbar(this.configService.mensajes.TituloAviso, response.toString(), 1, 2);
      this.volver();
    }, error => {
      console.error('Error al enviar la solicitud:', error);
      this.snackBarService.openSnackbar(this.configService.mensajes.TituloError, error.error, 0, 2);

    });
  }
}
